import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body16MainStyles } from "@constants/typography"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 24px 12px 12px;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid ${colors.dividerLineGray};
  box-sizing: border-box;
  border-radius: 6px;

  &:hover {
    cursor: pointer;
  }

  @media ${breakpoints.tablet} {
    padding: 0 24px 0 12px;
  }

  @media ${breakpoints.laptop} {
    padding: 0 36px 0 12px;
  }
`

const GatsbyLink = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
`

const ImageWrapper = styled.div`
  ${ImageHelperContainer} {
    flex-shrink: 0;
    width: 86px;
    height: 86px;

    img {
      object-fit: contain;
    }
  }
`

const Text = styled.div`
  ${body16MainStyles}
  flex-shrink: 0;
  margin-left: 16px;
`

interface ProductBlockSimpleProps {
  image: string
  title: string
  link?: string
  className?: string
  onClick?: () => void
}

const ProductBlockSimple = (props: ProductBlockSimpleProps) =>
  props.image ? (
    <GatsbyLink to={props.link || ""}>
      <Container className={props.className} onClick={props.onClick}>
        <ImageWrapper>
          <ImageHelper src={props.image} />
        </ImageWrapper>
        <Text>{props.title}</Text>
      </Container>
    </GatsbyLink>
  ) : null

export default ProductBlockSimple
